import {store} from '../../../store/store'
import page from '../../../components/page.vue'
import zixun from '../../../components/zixun.vue'
import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';
export default {
  name:"inforlist",
  data(){
    return {
        type:store.webType,
        locationCode:'',
        pageCount:3,
        pageNo:1,
        libCode:'',
        informationData:{},
        idS:[],
        totalPage:0,
    }
  },
  components:{
    page,
    zixun
  },

  watch: {
        $route() {
            this.queryData();
        }
  },
  beforeMount() {
      store.libraryNav.activeNav = '本馆资讯';
      this.queryData();
  },
  methods:{
    queryData(){
         this.locationCode = this.$route.query.code || "510107";
         this.pageNo=this.$route.query.page || 1;
         this.libCode =this.$route.query.libCode;
         var url = api.library.libNews.replace('{pageCount}', this.pageCount).replace('{pageNo}', this.pageNo).replace('{libCode}', this.libCode);
         ajaxUtil.ajaxJson(url, null, "GET", (data) => {
            this.informationData = data;
            this.totalPage=data.totalPage;
            if (this.informationData.resultList != null) {
                for (var i = 0; i < this.informationData.resultList.length; i++) {
                    this.idS.push(this.informationData.resultList[i].newsId);
                }
            }
        }, null, this);
    },
    paging: function (pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },
    toNewsInfo(newsId){
      var data={
        ids:this.idS,
        totalCount:this.informationData.totalCount,
        pageNo:this.pageNo,
        totalPage:this.informationData.totalPage,
        pageCount:this.informationData.pageCount,
      };
      StorageUtil.storeObject("informationInfo",data);
      this.$router.push({path: '/infordetails', query: {newsId: newsId, fromSearch: 0,code:this.locationCode,libCode:this.$route.query.libCode}});
    },

  }
}
